module.exports = __webpack_public_path__ + "img/img26.a0b456fb.jpg";